import { useState } from 'react';
import styles from './Settings.module.css';
import AIEduButton from '../../components/common/Button/AIEduButton';
import AIEduDropDown from '../../components/common/DropDown/AIEduDropDown';
import AIEduInputNumber from '../../components/common/Input/AIEduInputNumber';
import AIEduInputText from '../../components/common/Input/AIEduInputText';
import { COUNTRY_LIST } from '../../utils/CountryList';
import { showErrorToast } from '../../services/setup/ApiResponseHandler';
import {
    CITY_MAX_LENGTH,
    ORG_ADDRESS_MAX_LENGTH,
    ORG_NAME_MAX_LENGTH,
    STATE_MAX_LENGTH,
    ZIP_CODE_MAX_LENGTH,
} from '../../utils/Constants';

const OrganizationDetails = ({
    f,
    formState,
    handleFormUpdate,
    handleChange,
    handleFormReset,
}) => {
    const [isEdit, setIsEdit] = useState(false);

    const updateForm = (e) => {
        e.preventDefault();

        if (formState.organizationName?.trim().length >= 6) {
            handleFormUpdate();
            setIsEdit(false);
        } else {
            showErrorToast(
                'Organization name should be at least 6 characters long.'
            );
        }
    };

    const handleEdit = (e) => {
        e.preventDefault();
        setIsEdit(true);
    };

    const resetForm = (e) => {
        e.preventDefault();
        handleFormReset();
        setIsEdit(false);
    };

    return (
        <div className='mt-2'>
            <form>
                <div>
                    {isEdit ? (
                        <div className='flex gap-3'>
                            <AIEduButton
                                label='Update Details'
                                className={`btnPrimary`}
                                onClick={updateForm}
                            />
                            <AIEduButton
                                label='Cancel'
                                className={`btnSecondary`}
                                onClick={resetForm}
                            />
                        </div>
                    ) : (
                        <AIEduButton
                            label='Edit Details'
                            className={`btnPrimary`}
                            icon='pi pi-pen-to-square'
                            onClick={handleEdit}
                        />
                    )}
                </div>
                <div className='mt-4'>
                    <AIEduInputText
                        name='organizationName'
                        title={f({ id: 'AI_EDU_ORG_NAME' })}
                        titleStyle={styles.inputField}
                        suffix={<span style={{ color: 'red' }}>*</span>}
                        placeholder='Enter Organization Name'
                        value={formState.organizationName}
                        onChange={handleChange}
                        maxLength={ORG_NAME_MAX_LENGTH}
                        disabled={!isEdit}
                    />
                </div>
                <div className='flex justify-content-between mt-5'>
                    <div className={`${styles.orgAddr} ${styles.inputField}`}>
                        {f({ id: 'AI_EDU_ORG_ADDRESS' })}
                    </div>
                    {/* <div className={styles.divider} style={{ width: '100%' }} /> */}
                </div>
                <div>
                    <div className={styles.org_details_row}>
                        <AIEduInputText
                            name='address'
                            title={f({ id: 'AI_EDU_ADDRESS' })}
                            placeholder='Enter Address'
                            value={formState.address}
                            onChange={handleChange}
                            maxLength={ORG_ADDRESS_MAX_LENGTH}
                            disabled={!isEdit}
                        />
                        <AIEduInputText
                            name='city'
                            title={f({ id: 'AI_EDU_CITY' })}
                            placeholder='Enter City'
                            value={formState.city}
                            onChange={handleChange}
                            disabled={!isEdit}
                            maxLength={CITY_MAX_LENGTH}
                        />
                        <div
                            className='mt-3 flex flex-column'
                            style={{ gap: '2px' }}
                        >
                            <label>{f({ id: 'AI_EDU_COUNTRY' })}</label>
                            <AIEduDropDown
                                name='country'
                                placeholder='Select Country'
                                options={COUNTRY_LIST}
                                optionLabel='name'
                                value={formState.country}
                                onChange={handleChange}
                                disabled={!isEdit}
                            />
                        </div>
                        <AIEduInputText
                            name='state'
                            title={f({ id: 'AI_EDU_STATE_PROVINCE' })}
                            placeholder='Enter State/ Province'
                            value={formState.state}
                            onChange={handleChange}
                            disabled={!isEdit}
                            maxLength={STATE_MAX_LENGTH}
                        />
                        <AIEduInputNumber
                            name='zipCode'
                            title={f({ id: 'AI_EDU_ZIP_CODE' })}
                            placeholder='Enter Code'
                            value={formState.zipCode}
                            onValueChange={handleChange}
                            disabled={!isEdit}
                            useGrouping={false}
                            maxLength={ZIP_CODE_MAX_LENGTH}
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default OrganizationDetails;
